import React, { useEffect, useState } from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from '../../hooks/useAuth';
import Spinner from './Spinner';
import {hasAssignedModule, moduleForPath, readStoredModules} from '../../constants/modules';

export default function ProtectedRoute({children}:{children:React.ReactNode}){
  const {user,token,isAuthenticated,loading,loadUser}=useAuth();
  const location=useLocation();
  // On a fresh page load (refresh / direct URL), the token survives in localStorage
  // (see authSlice's initialState) but the `user` object does not — nothing was
  // calling loadUser() to rehydrate it via /auth/me, so every page rendered with
  // user=null until the person navigated somewhere that happened to set it another
  // way. Rehydrate exactly once here, the single place every protected page passes
  // through, before rendering children.
  const [rehydrating, setRehydrating] = useState(!!token && !user);
  useEffect(() => {
    if (token && !user) {
      loadUser().finally(() => setRehydrating(false));
    } else {
      setRehydrating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if(loading||rehydrating) return <div className="flex items-center justify-center min-h-screen"><Spinner size="12"/></div>;
  if(!isAuthenticated) return <Navigate to="/login" replace/>;
  const required=moduleForPath(location.pathname);
  if(!hasAssignedModule(user?.accessibleModules??readStoredModules(),required)){
    return <Navigate to="/dashboard" replace/>;
  }
  return <>{children}</>;
}
